import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { RadioGroup } from "@/components/ui/radio-group"
import { convertLanguageToISOCode } from "@/lib/language-to-iso-code"
import { RadioGroupItemCustom } from "@/modules/patients/agenda/teleconsultation/booking/components/radio-group-item"
import { TeleconsultationForm } from "@/modules/patients/agenda/teleconsultation/booking/teleconsultation-schema"
import { Language, LanguageValues } from "@/types/__generated__/union-types"

type LanguageItem = {
  label: string
  value: Language
}

const languageItems: LanguageItem[] = LanguageValues.map((l) => ({
  label: convertLanguageToISOCode(l),
  value: l,
}))

const LanguageSkill = ({ secondaryLanguages }: { secondaryLanguages: Language[] }) => {
  const { t } = useTranslation()
  const { control } = useFormContext<TeleconsultationForm>()

  return (
    <div className="grid gap-2">
      <label className="text-on-surface-subdued text-sm" data-testid="language-section-label">
        {t("common.language")}
      </label>
      <Controller
        control={control}
        name="language"
        render={({ field: { onChange, value } }) => (
          <RadioGroup value={value} className="flex flex-wrap gap-2">
            {languageItems.map((languageItem) => (
              <RadioGroupItemCustom
                key={languageItem.value}
                groupName="language-skill"
                {...languageItem}
                onClick={() => {
                  onChange(languageItem.value)
                }}
              />
            ))}
          </RadioGroup>
        )}
      />
      <div
        className="text-on-surface-subdued px-3 text-xs leading-4 tracking-[0.25px]"
        data-testid="language-description-section">
        {secondaryLanguages.length > 0
          ? t("patient.agenda.agentSkills.secondaryLanguagesList", {
              language: secondaryLanguages.map((language) => t(`common.languageList.${language.toLowerCase()}`)),
            })
          : t("patient.agenda.agentSkills.noSecondaryLanguages")}
      </div>
    </div>
  )
}

export { LanguageSkill }
